import Swiper from 'swiper/bundle';
import 'swiper/css';

export default class Main {
    constructor() {
        document.addEventListener('DOMContentLoaded', this.init.bind(this));
    }

    init() {
        this.setSlider();
        this.bindWindowEvents();
    }

    setSlider() {
        const sliderEl = document.querySelector('.js-game-bnr-swiper');
        const paginationEl = document.querySelector('.js-game-bnr-pagination');

        if (!sliderEl || !paginationEl) return;

        const slides = sliderEl.querySelectorAll('.swiper-slide');

        if (slides.length <= 1) return;

        new Swiper(sliderEl, {
            slidesPerView: 1,
            loop: true,
            speed: 650,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
            },
        });
    }

    bindWindowEvents() {
        const contentsEl = document.querySelector('.js-game-contents');
        const numEl = document.querySelector('.js-score-num');
        const shareEl = document.querySelector('.js-score-share');
        const closeEl = document.querySelector('.js-score-close');

        let score = 0;

        window.addEventListener('message', (event) => {
            if (event.origin !== 'https://appcdn.aniplex.co.jp') {
                console.error('security error', event.origin);
                return;
            }

            if (event.data.type === 'game') {
                score = event.data.data.score;
                numEl.textContent = score;
                contentsEl.classList.add('-gameover');
                console.log('gameからイベント受信:', score, event.data);
            }
        });

        shareEl.addEventListener('click', () => {
            window.open(
                `https://x.com/intent/tweet?text=%E3%81%82%E3%81%AA%E3%81%9F%E3%81%AE%E3%82%B9%E3%82%B3%E3%82%A2%E3%81%AF${score}%E7%82%B9%E3%81%A7%E3%81%99%EF%BC%81%0D%0A%0D%0A%23strangeFake%0D%0A%23Fate_strangeFake_Runner%0D%0A%23%E9%BB%84%E9%87%91%E3%81%A8%E7%8D%85%E5%AD%90%E3%82%B2%E3%83%BC%E3%83%A0%0D%0Ahttps%3A%2F%2Ffate-strange-fake.com%2Fspecial%2Fgame%2F`,
                '_blank'
            );
        });

        closeEl.addEventListener('click', () => {
            contentsEl.classList.remove('-gameover');
        });
    }
}
